import { styled } from '@mui/material';

export const Content = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
  justifyContent: 'center',
}));

export const AlignIcon = styled('div')(() => ({
  display: 'flex',
  alignSelf: 'center',
  userSelect: 'none',
  pointerEvents: 'none',
}));

export const TitleSection = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
  alignItems: 'center',
  paddingBottom: '1rem',
}));

export const SubTitleSection = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
  alignItems: 'center',
  maxWidth: '24.75rem',
}));

export const AlignButtons = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  gap: '1.5rem',
  justifyContent: 'space-evenly',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const Icon = styled('img')(() => ({
  width: '9.5rem',
}));
